export const LIVE_SEGMENT_ID = 'live'
